import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from './App.vue'

import vuetify from './plugins/vuetify'
import store from './store'



import Map from "@/views/Map"
import Areas from "@/views/Areas"
import Quests from "@/views/Quests"
import Bosses from "@/views/Bosses"
import Secrets from "@/views/Secrets"
import Tomes from "@/views/Tomes"
import Achievements from "@/views/Achievements"
import Stats from "@/views/Stats"
import Weapons from '@/views/Weapons'



const routes = [
  { name: 'default', path: '/', redirect: 'map' },
  { name: 'map', path: '/map', component: Map},
  { name: 'areas', path: '/areas', component: Areas },
  { name: 'quests', path: '/quests', component: Quests },
  { name: 'bosses', path: '/bosses', component: Bosses },
  { name: 'secrets', path: '/secrets', component: Secrets},
  { name: 'tomes', path: '/tomes', component: Tomes},
  { name: 'achievements', path: '/achievements', component: Achievements },
  { name: 'stats', path: '/stats', component: Stats},
  { name: 'weapons', path: '/weapons', component: Weapons}
]

const router = new VueRouter({
  routes // short for `routes: routes`
})

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.config.productionTip = false


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
